// @ts-nocheck
import createRecursiveFunction from './createRecursiveFunction';

const createRecursiveFunctionForAnalytics = callback => {
  return createRecursiveFunction(callback, {
    condition: () => window && typeof window.gtag === 'function',
  });
};

export default createRecursiveFunctionForAnalytics;
